import { IonItem } from '@ionic/react';
import React, { useState } from 'react';

import { setJobBoardSearchParams } from '../actions/searchActions';
import SearchCompanyName from '../components/SearchCompanyName';
import SearchIndustry from '../components/SearchIndustry';
import SearchJobType from '../components/SearchJobType';
import SearchLocation from '../components/SearchLocation';
import SearchQuery from '../components/SearchQuery';
import SearchRadius from '../components/SearchRadius';
import SearchSort from '../components/SearchSort';
import useSearchParamsFromUrl from '../hooks/useSearchParamsFromUrl';
import { defaultPostSearchParams } from '../services/searchUtils';
import { JSONApi, Search } from '../types';

import '../components/forms/CustomForm.scss';
import './Searchbox.scss';

export type JobBoardSearchFacets = {
  companyName: Search.FacetValue[] | undefined;
  industry: Search.FacetValue[] | undefined;
  jobType: Search.FacetValue[] | undefined;
};

type Props = {
  facets: JobBoardSearchFacets;
  group: JSONApi.GroupResource;
  isOpen: boolean;
};

const JobBoardSearchForm = ({ facets, group, isOpen }: Props) => {
  const [searchParams, setSearchParams] = useState<Search.PostParams>(defaultPostSearchParams());

  let searchFields: (keyof Search.PostParams)[] = ['query', 'sort'];
  if (group.attributes.locationFeaturesEnabled) {
    searchFields = searchFields.concat(['lat', 'lng', 'radius']);
  }
  if (group.attributes.careersEnabled) {
    searchFields = searchFields.concat(['companyName', 'industry', 'jobType']);
  }

  const sortOptions = [
    Search.SortOptions.AUTO,
    Search.SortOptions.POST_DATE,
    Search.SortOptions.TITLE
  ];

  useSearchParamsFromUrl<Search.PostParams>(
    searchFields,
    setSearchParams,
    searchParams,
    setJobBoardSearchParams
  );

  if (isOpen) {
    return (
      <div className="custom-form-wrapper searchbox">
        <IonItem>
          <SearchQuery<Search.PostParams>
            searchParams={searchParams}
            setSearchParams={setSearchParams}
          />
        </IonItem>
        <div className="ion-padding">
          <SearchCompanyName<Search.PostParams>
            facetValues={facets.companyName}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
          />
          <SearchJobType<Search.PostParams>
            facetValues={facets.jobType}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
          />
          <SearchIndustry<Search.PostParams>
            facetValues={facets.industry}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
          />
          {group.attributes.locationFeaturesEnabled && (
            <>
              <SearchLocation<Search.PostParams>
                searchParams={searchParams}
                setSearchParams={setSearchParams}
              />
              <SearchRadius<Search.PostParams>
                searchParams={searchParams}
                setSearchParams={setSearchParams}
              />
            </>
          )}
          <SearchSort<Search.PostParams>
            defaultOption={Search.SortOptions.AUTO}
            options={sortOptions}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
          />
        </div>
      </div>
    );
  }
  return null;
};

export default JobBoardSearchForm;
